
  export const strToHHMMSS = ({str}) => {
    let sec_num = parseInt(str, 10);
    let hours = Math.floor(sec_num / 3600);
    let minutes = Math.floor((sec_num - hours * 3600) / 60);
    let seconds = sec_num - hours * 3600 - minutes * 60;

    if (hours < 10) {
      hours = "0" + hours;
    }
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    if (seconds < 10) {
      seconds = "0" + seconds;
    }

    return hours + ":" + minutes + ":" + seconds;
  }

export const setBg = ({value}) => {
    //return `linear-gradient(to right, #d33d01 0%,#772200 ${value}%, #fff ${value}%, white 100%)`;
     return `linear-gradient(to right, white 0%,white ${value}%, transparent ${value}%, transparent 100%)`;
}
